<template>
  <div>

    <template v-if="tableType == 'default'" >
      <b-table id="documents-table-default" striped hover bordered responsive class="mt-3" :busy.sync="theTableIsBusy" :items="documents.data" :fields="fields" no-sort-reset @sort-changed="sortingChanged" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :tbody-tr-class="rowClass" :primary-key="'id'"
      :total-rows="totalRows" per-page="0" :currentPage="currentPage" :filter="filter" @filtered="onFiltered" :show-empty="rowEmpty" foot-clone :tfoot-class="'footer-summary'" :thead-class="'brand-color'">
        <template v-slot:head(checkbox)="data">
          <template v-if="!allDocsToggle">
            <fontAwesomeIcon @click="[checkAllDocs(), localToggle(true)]" :icon="['far', 'square']" class="showhand" size="2x"/>
          </template>
          <template v-if="allDocsToggle">
            <fontAwesomeIcon @click="[unCheckAllDocs(), localToggle(false)]" :icon="['far', 'check-square']" class="showhand" size="2x"/>
          </template>
        </template>
        <template v-slot:head(customer_ref)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(customer_name)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(client_data_1)="data">
          <span> {{ data.label }}</span>
        </template>
        <template v-slot:head(client_data_2)="data">
          <span> {{ data.label }}</span>
        </template>
        <template v-slot:head(type_name)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(document)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(pages)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(value)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(vat_value)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(payment_status)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(doc_status)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(date)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(post_house)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(send)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(currency)="data">
          <span> {{ t(data.label, data.label) }}</span>
        </template>
        <template class="busy-row" v-if="!isInfinite" v-slot:table-busy>
          <!--<div class="vld-parent spinner-row text-center">
            <loading :active.sync="theTableIsBusy"
            :can-cancel="false"
            :color="'#047bf8'"
            :loader="'dots'"
            :is-full-page="false"></loading>
          </div>-->
          <vcl-table v-if="isLoading" :rows="perPage" :columns="columnsAmount"></vcl-table>
        </template>
        <template v-slot:empty="scope">
          <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
        </template>
        <template v-slot:cell(checkbox)="data">
          <b-form-checkbox :value="data.item.id" :unchecked-value="undefined" v-model="documentsData.docsChecked" @change="collectDocStatus($event, {docId: data.item.id, status: data.item.batch_status, customer: data.item.customer_ref, reference: data.item.reference}); handleCheckbox(data.item.id)"></b-form-checkbox>
        </template>
        <template v-slot:cell(customer_ref)="data">
          <template v-if="(clientName == 'unis') || (clientName == 'unistest')">
            <template v-if="userLevel == 1.50">
              <span class="hide-color">{{ (data.item.customer_ref) ? data.item.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }}</span>
            </template>
            <template v-else>
              <router-link class="hide-color" :to="{ path: `/customers_accounts/manage_customers?page=1&per_page=20&customerReference=` + `${data.item.customer_ref}`}" :title="t('tooltipViewCustomerDetails', 'tooltipViewCustomerDetails')">
                  {{ data.item.customer_ref }}
              </router-link>
              <!--
              <a href="#" @click="routeToCustomers(data.item.customer.customer_ref)" :title="t('tooltipViewCustomerDetails', 'tooltipViewCustomerDetails')">
                  {{ data.item.customer.customer_ref }}
              </a>
              -->
            </template>
          </template>
          <template v-else>
            <template v-if="(Number(userLevel) > 0.50)">
              <router-link class="hide-color" :to="{ path: `/customers_accounts/manage_customers?page=1&per_page=20&customerReference=` + `${data.item.customer_ref}`}" :title="t('tooltipViewCustomerDetails', 'tooltipViewCustomerDetails')">
                  {{ data.item.customer_ref }}
              </router-link>
              <!--
              <a href="#" @click="routeToCustomers(data.item.customer.customer_ref)" :title="t('tooltipViewCustomerDetails', 'tooltipViewCustomerDetails')">
                  {{ data.item.customer.customer_ref }}
              </a>-->
            </template>
            <template v-else>
              <span class="hide-color">{{ (data.item.customer_ref) ? data.item.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }}</span>
            </template>
          </template>
        </template>
        <template v-slot:cell(customer_name)="data">
          <span class="hide-color" :title="data.item.customer_name">{{ data.item.customer_name | truncate(30) }}</span>
        </template>
        <template v-slot:cell(type_name)="data">
          <span class="hide-color">{{ data.item.type_name }}</span>
        </template>
        <template v-slot:cell(document)="data">
          <!-- NS-10011 Commented router links to replace with span elements, that way we can avoid main page refresh/reload, PW -->
          <span class="url showhand" @click="setAsRead(data.item.id); routeToDocumentView(data.item.id, null, 'online')" :title="`${data.item.reference} - ${t('batchNumber', 'batchNumber')} ${data.item.batch}`">{{ data.item.reference }}</span>
          <!--<router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'online' }}" :title="`${data.item.reference} - ${t('batchNumber', 'batchNumber')} ${data.item.batch}`" target="_blank">
            {{ data.item.reference }}
          </router-link>-->
          <template v-if="((Number(userLevel) > 1.60) && (proof == 'proof') && (data.item.batch_status != 'rejected')) || (Number(userLevel) > 2.50) || ((Number(userLevel) > 1.60) && (data.item.batch_status != 'rejected') && (clientName == 'tota'))">
            <template v-if="data.item.email_cover == 1">
              <span class="url showhand" @click="routeToDocumentView(data.item.id, null, 'email_cover')" :title="`${data.item.reference} Email Cover Sheet`" target="_blank">[e]</span>
              <!--<router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'email_cover'}}" target="_blank">
                [e]
              </router-link>-->
            </template>
            <template v-if="data.item.fax_cover == 1">
              <span class="url showhand" @click="routeToDocumentView(data.item.id, null, 'fax_cover')" :title="`${data.item.reference} Fax Cover Sheet`" target="_blank">[f]</span>
              <!--<router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'fax_cover' }}" target="_blank">
							  [f]
							</router-link>-->
            </template>
            <template v-if="data.item.post_cover == 1">
              <span class="url showhand" @click="routeToDocumentView(data.item.id, null, 'post_cover')" :title="`${data.item.reference} Post Cover Sheet`" target="_blank">[p]</span>
              <!--<router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'post_cover' }}" target="_blank">
							  [p]
							</router-link>-->
            </template>
          </template>
          <template v-if="userLevel == 3.00">
            <fontAwesomeIcon :icon="['fas', 'info-circle']" size="lg" :id="'info-' + data.item.id"
            @click="modalCreator({id: 'infoModal', title: t('documentInfoModalHead','documentInfoModalHead'), level: 'main', open: 'open'}, data.item, $event.target)"
            class="text-primary showhand align-middle ml-1" visibility="visible"/>
          </template>
          <span v-if="data.item.is_read > 0" class="text-white bg-green px-1 ml-1" v-b-tooltip.hover.html="readTooltip(data.item.read_by, data.item.read_on)">R</span>
          <template v-if="data.item.enable_document_download_info">
            <span class="text-white bg-blue px-1 ml-1" v-if="data.item.downloaded == 1" v-b-tooltip.hover.html="downloadTooltip(data.item.downloaded_by, data.item.downloaded_on)">D</span>
          </template>
          <span v-if="data.item.is_hidden == 3" class="text-white bg-yellow px-1 ml-1" title="Can only be unhidden by newsnet staff">N</span>
          <span v-if="(clientName == 'jfox') && (data.item.accepted)">Y</span>
        </template>
        <!-- EIPP-172 Added new cell, PW -->
        <template v-slot:cell(original_invoice)="data">
          <span class="url showhand" @click="routeToDocumentView(data.item.original_invoice, null, 'online')" :title="`${data.item.reference} - ${t('batchNumber', 'batchNumber')} ${data.item.batch}`">
            <template v-if="data.item.original_invoice_name"> 
              {{ data.item.original_invoice_name }}
            </template>
            <template v-else>
              {{ data.item.original_invoice }}
            </template>
          </span>
        </template>
        <template v-slot:cell(pages)="data">
          <template v-if="(Number(userLevel) > 1.60)"><span class="hide-color">{{ data.item.num_of_pages | numberFormat(0)}}</span></template>
        </template>
        <template v-slot:cell(value)="data">
          <template v-if="displaySettings.totalValueReq != 0.0">
            <template v-if="displaySettings.formatValues">
              <span class="hide-color"> {{ data.item.total_value | thousandsFormatter() }}<span v-if="(clientName == 'hobatest' || clientName == 'hoba') && data.item.batch_name == 'ContractInvoice'">{{ t('gbpCurrencySymbol', 'gbpCurrencySymbol') }}</span></span>
            </template>
            <template v-else>
              <span class="hide-color"> {{ data.item.total_value | numberFormat(2)}}<span v-if="(clientName == 'hobatest' || clientName == 'hoba') && data.item.batch_name == 'ContractInvoice'">{{ t('gbpCurrencySymbol', 'gbpCurrencySymbol') }}</span></span>
            </template>
          </template>
        </template>
        <template v-slot:cell(customer_type)="data">
          <span class="hide-color">{{ data.item.customer_type }}</span>
        </template>
        <template v-slot:cell(invoice_type)="data">
          <span class="hide-color">{{ data.item.invoice_type }}</span>
        </template>
        <template v-slot:cell(client_data_1)="data">
          <span class="hide-color">{{ data.item.client_data_1 }}</span>
        </template>
        <template v-slot:cell(client_data_2)="data">
          <span class="hide-color">{{ data.item.client_data_2 }}</span>
        </template>
        <template v-slot:cell(vat_value)="data">
          <template v-if="(displaySettings.vatValueReq != 0.0) && (userLevel >= displaySettings.vatValueReq) ">
            <template v-if="displaySettings.formatValues">
              <span class="hide-color">{{ data.item.vat_value | thousandsFormatter() }}<span v-if="(clientName == 'hobatest' || clientName == 'hoba') && data.item.batch_name == 'ContractInvoice'">{{ t('gbpCurrencySymbol', 'gbpCurrencySymbol') }}</span></span>
            </template>
            <template v-else>
              <span class="hide-color">{{ data.item.vat_value }} <span v-if="(clientName == 'hobatest' || clientName == 'hoba') && data.item.batch_name == 'ContractInvoice'">{{ t('gbpCurrencySymbol', 'gbpCurrencySymbol') }}</span></span>
            </template>
          </template>
        </template>
        <template v-slot:cell(payment_status)="data">
          <template v-if="data.item.payment_status != 'paid'">
           <span class="hide-color">
             {{ data.item.payment_status | paymentColumnText(data.item.type_name, getUserDocTypePaymentAllowed) }}
            </span>
          </template>
          <template v-else>
           <a href="javascript:;" @click="openReceiptModal(data.item.id)" class="hide-color">
             {{ data.item.payment_status | paymentColumnText(data.item.type_name, getUserDocTypePaymentAllowed) }}
            </a>
          </template>
        </template>
        <template v-slot:cell(doc_status)="data">
          <span v-if="(userLevel == 0.00) && (clientName != 'tota') && ( (clientName != 'easy' && clientName != 'easytest') || ( (!isHeadUser) || (data.item.customer_ref == headUserCustomerRef) ) )" >
            <select v-if="displaySettings.clientMarks" name="doc_status" @change="changeMark">
              <option v-for="mark in displaySettings.clientMarks" :value="mark.id" :key="mark.id" :selected="data.item.doc_status == mark.id">{{ mark.mark_symbol }}</option>
            </select>
          </span>
          <span v-else-if="(clientName == 'tota') && (belongToPrincipal('INENCO')) && (Number(userLevel) > 1.60)">
            <span v-for="mark in displaySettings.clientMarks" :key="mark.id" >
              <span v-if="data.item.doc_status == mark.id">
                <span class="hide-color" :title="data.item.marked_by">{{ mark.mark_symbol }} : {{ data.item.marked_on }}</span>
              </span>
            </span>
          </span>
          <span v-else>
            <span v-for="mark in displaySettings.clientMarks" :key="mark.id">
              <span class="hide-color" v-if="data.item.doc_status == mark.id">{{ mark.mark_symbol }}</span>
            </span>
          </span>
        </template>
        <template v-slot:cell(date)="data">
          <template v-if="(Number(userLevel) > 0.50) && (displaySettings.deliveryReports)">
            <router-link class="hide-color" :to="{name:'delivery_reports', query: {page: 1, per_page: 20}, params: {docs: Array.of(data.item.id)}}" :title="t('viewDeliveryDetails', 'viewDeliveryDetails')">
                {{ data.item.document_date | clientDateFormatter(datePickerFormat, false) }}
            </router-link>
            <!--
            <a href="#" @click="routeToDeliveryReport(data.item.id)" :title="t('viewDeliveryDetails', 'viewDeliveryDetails')">
              {{ data.item.document_date }}
            </a>
          -->
          </template>
          <template v-else>
            <span class="hide-color">{{ data.item.document_date | clientDateFormatter(datePickerFormat, false) }}</span>
          </template>
        </template>
        <template v-slot:cell(post_house)="data">
          <template v-if="data.item.post_house">
            <span class="hide-color">{{ data.item.post_house }}</span>
          </template>
        </template>
        <template v-slot:cell(send)="data">
          <div v-if="(Number(userLevel) > 1.60) && (proof == 'proof') && (data.item.batch_status != 'rejected')" class="d-flex justify-content-center">
            <template v-if="data.item.row_tool_option_email == 1">
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'at']" class="text-success" size="lg" :title="'Document will be sent by email'" />
              </span>
            </template>
            <template v-else>
              <span class="px-1">
                <fontAwesomeIcon v-if="data.item.row_tool_option_email == 2" :icon="['fas', 'at']" class="text-danger" size="lg" :title="'Document will not be sent by email - email disabled'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_email == 3" :icon="['fas', 'at']" class="text-danger" size="lg" :title="'Document will not be sent by email - no email present'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_email == 4" :icon="['fas', 'at']" class="text-danger" size="lg" :title="'Document will not be sent by email - no email present & function disabled'"/>
              </span>
            </template>
            <template v-if="data.item.row_tool_option_fax == 1">
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'fax']" class="text-success" size="lg" :title="'Document will be sent by fax'"/>
              </span>
            </template>
            <template v-else>
              <span class="px-1">
                <fontAwesomeIcon v-if="data.item.row_tool_option_fax == 2" :icon="['fas', 'fax']" class="text-danger" size="lg" :title="'Document will not be sent by fax - fax disabled'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_fax == 3" :icon="['fas', 'fax']" class="text-danger" size="lg" :title="'Document will not be sent by fax - no fax present'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_fax == 4" :icon="['fas', 'fax']" class="text-danger" size="lg" :title="'Document will not be sent by fax - no fax present & function disabled'"/>
              </span>
            </template>
            <template v-if="data.item.row_tool_option_post == 1">
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'envelope']" class="text-success" size="lg" :title="'Document will be sent by post'"/>
              </span>
            </template>
            <template v-else>
              <span class="px-1">
                <fontAwesomeIcon v-if="data.item.row_tool_option_post == 2" :icon="['fas', 'envelope']" class="text-danger" size="lg" :title="'Document will not be sent by post - post disabled'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_post == 3" :icon="['fas', 'envelope']" class="text-danger" size="lg" :title="'Document will not be sent by post - no address present'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_post == 4" :icon="['fas', 'envelope']" class="text-danger" size="lg" :title="'Document will not be sent by post - no address present & function disabled'"/>
              </span>
            </template>
            <template v-if="data.item.row_tool_option_datax">
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'download']" class="text-success" size="lg" :title="'Document will be sent by data transfer'"/>
              </span>
            </template>
            <template v-else>
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'download']" class="text-danger" size="lg" :title="'Document will not be sent by data transfer - data transfer disabled'"/>
              </span>
            </template>
            <!-- EIPP-477 Document deletion flag -->
            <template v-if="(Number(userLevel) >= 2.00) && data.item.to_be_deleted">
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'times']" class="text-danger" size="lg" :title="'This document will be deleted'"/>
              </span>
            </template>
          </div>
          <div v-else class="d-flex justify-content-center">
            <span @click="modalCreator({id: 'emailModal', title: t('documentsSearchEmailModalHead','documentsSearchEmailModalHead'), level: 'main',  open: 'open', entries: 'single', wm: 'none', perm_wm_allowed: false}, data.item, $event.target)" class="showhand">
              <fontAwesomeIcon :icon="['fas', 'at']" class="text-success" size="lg"/>
            </span>
            <span @click="modalCreator({id: 'faxModal', title: t('documentsSearchFaxModalHead','documentsSearchFaxModalHead'), level: 'main', open: 'open', entries: 'single', type: 'default'}, data.item, $event.target)"  class="showhand">
              <fontAwesomeIcon :icon="['fas', 'fax']" class="bottom-icon" size="lg"/>
            </span>
            <!--<span @click="modalCreator({id: 'postModal', title: t('documentsSearchPostHead','documentsSearchPostHead'), open: 'open', entries: 'single', type: 'default'}, data.item, $event.target)" class="showhand double-icon" >-->
            <span>
              <fontAwesomeIcon  :icon="['fas', 'envelope']" class="text-faded-gray" size="lg"/>
            </span>
          </div>
        </template>
        <template v-slot:cell(currency)="data">
          <span class="hide-color"> {{data.item.currency}} </span>
        </template>
        <template v-slot:foot(checkbox)="data">
        </template>
        <template v-slot:foot(customer_ref)="data">
        </template>
        <template v-slot:foot(customer_name)="data">
        </template>
        <template v-slot:foot(client_data_1)="data">
        </template>
        <template v-slot:foot(client_data_2)="data">
        </template>
        <template v-slot:foot(type_name)="data">
        </template>
        <template v-slot:foot(invoice_type)="data">
          <div></div>
        </template>
        <template v-slot:foot(document)="data">
        </template>
        <template v-slot:foot(customer_type)="data">
          <div></div>
        </template>
        <template v-slot:foot(pages)="data">
        </template>
        <template v-slot:foot(original_invoice)="data">
          <div></div>
        </template>
        <template v-slot:foot(value)="data">
          <span v-if="Object.entries(calculations).length !== 0" class="footer-summary-value" >
            <template v-if="calculations.documentsSummary && calculations.documentsSummary.documentsPageTotal">
              <template v-if="displaySettings.formatValues">
                {{ calculations.documentsSummary.documentsPageTotal | thousandsFormatter() }}
              </template>
              <template v-else>
                {{ calculations.documentsSummary.documentsPageTotal | removeSeparator() }}
              </template>
            </template>
            <template v-else>
              <template v-if="displaySettings.formatValues">
                {{ calculations.documentsSummary.documentsPageTotal | thousandsFormatter() }}
              </template>
              <template v-else>
                {{ calculations.documentsSummary.documentsPageTotal | removeSeparator() }}
              </template>
            </template>
          </span>
          <span v-else></span>
        </template>
        <template v-slot:foot(vat_value)="data">
          <span v-if="Object.entries(calculations).length !== 0" class="footer-summary-value">
            <template v-if="calculations.documentsSummary && calculations.documentsSummary.documentsPageVat">
              <template v-if="displaySettings.formatValues">
                {{ calculations.documentsSummary.documentsPageVat | thousandsFormatter() }}
              </template>
              <template v-else>
                {{ calculations.documentsSummary.documentsPageVat | removeSeparator() }}
              </template>
            </template>
            <template v-else>
              <template v-if="displaySettings.formatValues">
                {{ calculations.documentsSummary.documentsTotalValue | thousandsFormatter() }}
              </template>
              <template v-else>
                {{ calculations.documentsSummary.documentsTotalValue | removeSeparator() }}
              </template>
            </template>
          </span>
          <span v-else></span>
        </template>
        <template v-slot:foot(payment_status)="data">
        </template>
        <template v-slot:foot(doc_status)="data">
        </template>
        <template v-slot:foot(date)="data">
        </template>
        <template v-slot:foot(post_house)="data">
        </template>
        <template v-slot:foot(send)="data">
        </template>
        <template v-slot:foot(currency)="data">
        </template>
      </b-table>
    </template>
    <template v-if="tableType == 'client-specific'">
      <b-table id="documents-table-client-specific" foot-clone striped hover bordered responsive class="mt-3" :busy.sync="theTableIsBusy" :items="documents.data" :fields="fields" no-sort-reset @sort-changed="sortingChanged" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :tbody-tr-class="rowClass" :primary-key="'id'"
      :total-rows="totalRows" per-page="0" :currentPage="currentPage" :filter="filter" @filtered="onFiltered" :show-empty="rowEmpty" :tfoot-class="'footer-summary'" :thead-class="'brand-color'">
        <template v-slot:head(checkbox)="data">
          <template v-if="!allDocsToggle">
            <fontAwesomeIcon @click="[checkAllDocs(), localToggle(true)]" :icon="['far', 'square']" class="showhand" size="lg"/>
          </template>
          <template v-if="allDocsToggle">
            <fontAwesomeIcon @click="[unCheckAllDocs(), localToggle(false)]" :icon="['far', 'check-square']" class="showhand" size="lg"/>
          </template>
        </template>
        <template v-slot:head(customer_ref)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(client_data_2)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(customer_name)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(type_name)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(document)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(pages)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(value)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(client_data_1)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(vat_value)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(payment_status)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(doc_status)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(date)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(post_house)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(send)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(currency)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-if="!isInfinite" class="busy-row" v-slot:table-busy>
          <vcl-table v-if="isLoading" :rows="perPage" :columns="columnsAmount"></vcl-table>
        </template>
        <template v-slot:empty="scope">
          <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
        </template>
        <template v-slot:cell(checkbox)="data">
          <b-form-checkbox :value="data.item.id" :unchecked-value="undefined" v-model="documentsData.docsChecked" @change="collectDocStatus($event, {docId: data.item.id, status: data.item.batch_status, customer: data.item.customer_ref, reference: data.item.reference}); handleCheckbox(data.item.id)"></b-form-checkbox>
        </template>
        <template v-slot:cell(customer_ref)="data">
          <template v-if="(Number(userLevel) > 0.50)" >
            <router-link class="hide-color" :to="{ path: `/customers_accounts/manage_customers?page=1&per_page=20&customerReference=` + `${data.item.customer_ref}`}" :title="t('tooltipViewCustomerDetails', 'tooltipViewCustomerDetails')">
              {{ (data.item.customer_ref) ? data.item.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }}
            </router-link>
            <!--
            <a :id="`cust_reference_${data.item.id}`" href="javascript:;" @click="routeToCustomers(data.item.customer.customer_ref)" :title="t('tooltipViewCustomerDetails', 'tooltipViewCustomerDetails')">
                {{ (data.item.customer.customer_ref) ? data.item.customer.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }}
            </a>
            -->
          </template>
          <template v-else>
            <span class="hide-color" :id="'cust_reference_' + data.item.id"> {{ (data.item.customer_ref) ? data.item.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }} </span>
          </template>
        </template>
        <template v-slot:cell(client_data_2)="data">
          <template v-if="(clientName == 'rlus') || (clientName == 'rlustest')">
            <template v-if="(Number(userLevel) > 0.50)">
              <router-link class="hide-color" :to="{ path: `/customers_accounts/manage_customers?page=1&per_page=20&customerReference=` + `${data.item.client_data_2}`}" :title="t('tooltipViewCustomerDetails', 'tooltipViewCustomerDetails')">
                {{ (data.item.client_data_2) ? data.item.client_data_2 : t('labelNotYetAssigned', 'labelNotYetAssigned') }}
              </router-link>
              <!--
              <a :id="`cust_reference_${data.item.id}`" href="#" @click="routeToCustomers(data.item.client_data_2)" :title="t('tooltipViewCustomerDetails', 'tooltipViewCustomerDetails')">
                  {{ (data.item.client_data_2) ? data.item.client_data_2 : t('labelNotYetAssigned', 'labelNotYetAssigned') }}
              </a>
            -->
            </template>
            <template v-else>
              <span class="hide-color">{{ (data.item.customer_ref) ? data.item.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }}</span>
            </template>
          </template>
          <template v-else>
            <span class="hide-color">{{ data.item.client_data_2 ? data.item.client_data_2 : ''  }}</span>
          </template>
        </template>
        <template v-slot:cell(customer_name)="data">
          <span class="hide-color">{{ data.item.customer_name }}</span>
        </template>
        <template v-slot:cell(type_name)="data">
          <span v-if="(clientName == 'ufox') || (clientName == 'ufoxtest')">
            <a href="#" class="hide-color" @click="modalCreator({id: 'foxPromotionalPriceForm', title: t('foxPromotionalPriceFormModalHead','foxPromotionalPriceFormModalHead'), level: 'main', open: 'open', type: 'default'}, $event.target)">
              {{ data.item.type_name }}
            </a>
          </span>
          <span v-else class="hide-color">
            {{ data.item.type_name }}
          </span>
        </template>
        <template v-slot:cell(document)="data">
          <!-- NS-10011 Commented router links to replace with span elements, that way we can avoid main page refresh/reload, PW -->
          <span class="url showhand" @click="setAsRead(data.item.id); routeToDocumentView(data.item.id, null, 'online')" :title="`${data.item.reference} - ${t('batchNumber', 'batchNumber')} ${data.item.batch}`">{{ data.item.reference }}</span>
          <!--<router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'online' }}" v-on:click.native="setasRead(data.item.id)" :title="`${data.item.reference} - ${t('batchNumber', 'batchNumber')} ${data.item.batch}`" target="_blank">
            {{ data.item.reference }}
          </router-link>-->
          <!--<template v-if="(displaySettings.isAdmin && proof && !proofRejected) || displaySettings.isNewsnet">-->
          <template v-if="((Number(userLevel) > 1.60) && (proof == 'proof') && (data.item.batch_status != 'rejected')) || (Number(userLevel) > 2.50)">
            <template v-if="data.item.email_cover == 1">
              <span class="url showhand" @click="routeToDocumentView(data.item.id, null, 'email_cover')" :title="`${data.item.reference} Email Cover Sheet`" target="_blank">[e]</span>
              <!--<router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'email_cover' }}" target="_blank">
                [e]
              </router-link>-->
            </template>
            <template v-if="data.item.fax_cover == 1">
              <span class="url showhand" @click="routeToDocumentView(data.item.id, null, 'fax_cover')" :title="`${data.item.reference} Fax Cover Sheet`" target="_blank">[f]</span>
              <!--<router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'fax_cover' }}" target="_blank">
							  [f]
							</router-link>-->
            </template>
            <template v-if="data.item.post_cover == 1">
              <span class="url showhand" @click="routeToDocumentView(data.item.id, null, 'post_cover')" :title="`${data.item.reference} Post Cover Sheet`" target="_blank">[p]</span>
              <!--<router-link class="hide-color" :to="{ name: 'view_document', params: { id: data.item.id, type: 'post_cover' }}" target="_blank">
							  [p]
							</router-link>-->
            </template>
          </template>
          <template v-if="userLevel == 3.00">
            <fontAwesomeIcon :icon="['fas', 'info-circle']" size="lg" :id="'info-' + data.item.id"
            @click="modalCreator({id: 'infoModal', title: t('documentInfoModalHead','documentInfoModalHead'), level: 'main', open: 'open'}, data.item, $event.target)"
            class="text-primary showhand align-middle ml-1" visibility="visible"/>
          </template>
          <span v-if="data.item.is_read > 0" class="text-white bg-green px-1 ml-1" v-b-tooltip.hover.html="readTooltip(data.item.read_by, data.item.read_on)">R</span>
          <template v-if="data.item.enable_document_download_info">
            <span class="text-white bg-blue px-1 ml-1" v-if="data.item.downloaded == 1" v-b-tooltip.hover.html="downloadTooltip(data.item.downloaded_by, data.item.downloaded_on)">D</span>
          </template>
          <span v-if="data.item.is_hidden == 3" class="text-white bg-yellow px-1 ml-1" title="Can only be unhidden by newsnet staff">N</span>
          <span class="hide-color" v-if="data.item.accepted"> Accepted</span>
        </template>
        <!-- EIPP-172 Added new cell, PW -->
        <template v-slot:cell(original_invoice)="data">
          <span class="url showhand" @click="routeToDocumentView(data.item.original_invoice, null, 'online')" :title="`${data.item.reference} - ${t('batchNumber', 'batchNumber')} ${data.item.batch}`">
            <template v-if="data.item.original_invoice_name"> 
              {{ data.item.original_invoice_name }}
            </template>
            <template v-else>
              {{ data.item.original_invoice }}
            </template>
          </span>
        </template>
        <template v-slot:cell(pages)="data">
          <span class="hide-color">{{ data.item.num_of_pages | numberFormat(0)}}</span>
        </template>
        <template v-slot:cell(customer_type)="data">
          <span class="hide-color">{{ data.item.customer_type }}</span>
        </template>
        <!-- EIPP-327 Added customer type name, PW -->
        <template v-slot:cell(customer_type_name)="data">
          <span class="hide-color">{{ data.item.customer_type_name }}</span>
        </template>
        <template v-slot:cell(invoice_type)="data">
          <span class="hide-color">{{ data.item.invoice_type }}</span>
        </template>
        <template v-slot:cell(value)="data">
          <template v-if="displaySettings.formatValues">
            <span class="hide-color">{{ data.item.total_value | thousandsFormatter() }}<span v-if="(clientName == 'hobatest' || clientName == 'hoba') && data.item.batch_name == 'ContractInvoice'">{{ t('gbpCurrencySymbol', 'gbpCurrencySymbol') }}</span></span>
          </template>
          <template v-else>
            <span class="hide-color">{{ data.item.total_value | numberFormat(2)}} <span v-if="(clientName == 'hobatest' || clientName == 'hoba') && data.item.batch_name == 'ContractInvoice'">{{ t('gbpCurrencySymbol', 'gbpCurrencySymbol') }}</span></span>
          </template>
          <!-- NS-9511 DL - new functionality for online payments	-->
          <router-link class="text-success" :to="{ name: 'payment_summary', params: { id: data.item.id }}" target="_blank" v-if="data.item.payed_online">
            <fontAwesomeIcon :icon="['fa','credit-card']" size="1x" class="ml-2"/>
          </router-link>
        </template>
        <template v-slot:cell(total_gbp)="data">
          <span class="hide-color" v-if="data.item.total_gbp">{{ data.item.total_gbp }}</span>
          <span v-else></span>
        </template>
        <template v-slot:cell(total_eur)="data">
          <span class="hide-color" v-if="data.item.total_eur">{{ data.item.total_eur }}</span>
          <span v-else></span>
        </template>
        <template v-slot:cell(total_chf)="data">
          <span class="hide-color" v-if="data.item.total_chf">{{ data.item.total_chf }}</span>
          <span v-else></span>
        </template>
        <template v-slot:cell(total_aud)="data">
          <span class="hide-color" v-if="data.item.total_aud">{{ data.item.total_aud }}</span>
          <span v-else></span>
        </template>
        <template v-slot:cell(total_nok)="data">
          <span class="hide-color" v-if="data.item.total_nok">{{ data.item.total_nok }}</span>
          <span v-else></span>
        </template>
        <template v-slot:cell(total_pln)="data">
          <span class="hide-color" v-if="data.item.total_pln">{{ data.item.total_pln }}</span>
          <span v-else></span>
        </template>
        <template v-slot:cell(total_rub)="data">
          <span class="hide-color" v-if="data.item.total_rub">{{ data.item.total_rub }}</span>
          <span v-else></span>
        </template>
        <template v-slot:cell(total_sek)="data">
          <span class="hide-color" v-if="data.item.total_sek">{{ data.item.total_sek }}</span>
          <span v-else></span>
        </template>
        <template v-slot:cell(total_usd)="data">
          <span class="hide-color" v-if="data.item.total_usd">{{ data.item.total_usd }}</span>
          <span v-else></span>
        </template>
        <template v-slot:cell(total_nzd)="data">
          <span class="hide-color" v-if="data.item.total_nzd">{{ data.item.total_nzd }}</span>
          <span v-else></span>
        </template>
        <template v-slot:cell(client_data_1)="data">
          <span class="hide-color">{{ data.item.client_data_1 ? data.item.client_data_1 : ''}}</span>
        </template>
        <template v-slot:cell(ship_to)="data">
          <span class="hide-color">{{ data.item.ship_to ? data.item.ship_to : ''}}</span>
        </template>
        <template v-slot:cell(vat_value)="data">
          <template v-if="displaySettings.formatValues">
            <span class="hide-color">{{ data.item.vat_value | thousandsFormatter() }}<span v-if="(clientName == 'hobatest' || clientName == 'hoba') && data.item.batch_name == 'ContractInvoice'">{{ t('gbpCurrencySymbol', 'gbpCurrencySymbol') }}</span></span>
          </template>
          <template v-else>
            <span class="hide-color">{{ data.item.vat_value }} <span v-if="(clientName == 'hobatest' || clientName == 'hoba') && data.item.batch_name == 'ContractInvoice'">{{ t('gbpCurrencySymbol', 'gbpCurrencySymbol') }}</span></span>
          </template>
        </template>
        <template v-slot:cell(payment_status)="data">
          <template v-if="data.item.payment_status != 'paid'">
           <span class="hide-color">
             {{ data.item.payment_status | paymentColumnText(data.item.type_name, getUserDocTypePaymentAllowed) }}
            </span>
          </template>
          <template v-else>
           <a href="javascript:;" @click="openReceiptModal(data.item.id)" class="hide-color">
             {{ data.item.payment_status | paymentColumnText(data.item.type_name, getUserDocTypePaymentAllowed) }}
            </a>
          </template>
        </template>
        <template v-slot:cell()="data">
          <template v-if="data.field.type == 'currency_value'">
            <span class="hide-color">{{ calculations.documentsCurrency[data.field.key][data.item.id] }}</span>
          </template>
        </template>
        <template v-slot:cell(doc_status)="data">
          <template v-if="isMarkRequired && (proof == 'approved')">
            <template v-if="(Number(userLevel) == 0.00)">
              <select v-if="displaySettings.clientMarks" name="doc_status" @change="changeMark">
                <option v-for="mark in displaySettings.clientMarks" :value="mark.id" :key="mark.id" :selected="data.item.doc_status == mark.id">{{ mark.mark_symbol }}</option>
              </select>
            </template>
            <template v-else-if="Number(userLevel) == 3.00">
              <span v-for="mark in displaySettings.clientMarks" :key="mark.id">
                <span v-if="data.item.doc_status == mark.id">
                  <span class="hide-color" :title="data.item.marked_by">{{ mark.mark_symbol }}</span>
                </span>
              </span>
            </template>
            <template v-else>
              <template v-if="belongToPrincipal('INENCO') || (Number(userLevel) == 1.60)">
                <span v-for="mark in displaySettings.clientMarks" :key="mark.id">
                  <span v-if="data.item.doc_status == mark.id">
                    <span class="hide-color" :title="data.item.marked_by">{{ mark.mark_symbol }} : {{ data.item.marked_on }}</span>
                  </span>
                </span>
              </template>
              <template v-else>
                <span v-for="mark in displaySettings.clientMarks" :key="mark.id">
                  <span class="hide-color" v-if="data.item.doc_status == mark.id">{{ mark.mark_symbol }}</span>
                </span>
              </template>
            </template>
          </template>
        </template>
        <template v-slot:cell(date)="data">
          <template v-if="(Number(userLevel) > 0.50) && (displaySettings.deliveryReports)">
            <router-link class="hide-color" :to="{ name: 'delivery_reports', query: {page: 1, per_page: 20}, params: {docs: Array.of(data.item.id)}}" :title="t('viewDeliveryDetails', 'viewDeliveryDetails')">
                {{ data.item.document_date | clientDateFormatter(datePickerFormat, false) }}
            </router-link>
            <!--
            <a href="#" @click="routeToDeliveryReport(data.item.id)" :title="t('viewDeliveryDetails', 'viewDeliveryDetails')">
              {{ data.item.document_date }}
            </a>
          -->
          </template>
          <template v-else>
            <span class="hide-color">{{ data.item.document_date | clientDateFormatter(datePickerFormat, false) }}</span>
          </template>
          <!--{{data.item.id}}-->
        </template>
        <template v-slot:cell(post_house)="data">
          <template v-if="(Number(userLevel) > 2.50)">
            <template v-if="data.item.post_house">
              <template v-if="(proof == 'proof')">
                <span class="url showhand hide-color" @click="modalCreator({id: 'posthouseModal', title: t('documentsSearchChangePosthouseModalHead','documentsSearchChangePosthouseModalHead'), level: 'main', open: 'open', entries: 'single'}, {docsChecked: [data.item.id]}, $event.target)" :title="t('changePostHouse', 'changePostHouse')">
                  {{ data.item.post_house }}
                </span>
                <!--
                <router-link :to="{ path: `/posthouse/change?docId=` + `${data.item.id}`}" :title="t('changePostHouse', 'changePostHouse')">
                  {{ data.item.document_post_house.post_house }}
                </router-link>
              -->
              </template>
              <template v-else>
                <span class="hide-color">{{ data.item.post_house }}</span>
              </template>
            </template>
          </template>
          <template v-else>
            <span class="hide-color">{{ t('postHouseNTOS', 'postHouseNTOS') }}</span>
          </template>
        </template>
        <template v-slot:cell(send)="data">
          <!--<div v-if="data.item.batch.batch_status == 'proof'"> -->
          <div v-if="(proof == 'proof')" class="d-flex justify-content-center">
            <template v-if="data.item.row_tool_option_email == 1">
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'at']" class="text-success" size="lg" :title="'Document will be sent by email'" />
              </span>
            </template>
            <template v-else>
              <span class="px-1">
                <fontAwesomeIcon v-if="data.item.row_tool_option_email == 2" :icon="['fas', 'at']" class="text-danger" size="lg" :title="'Document will not be sent by email - email disabled'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_email == 3" :icon="['fas', 'at']" class="text-danger" size="lg" :title="'Document will not be sent by email - no email present'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_email == 4" :icon="['fas', 'at']" class="text-danger" size="lg" :title="'Document will not be sent by email - no email present & function disabled'"/>
              </span>
            </template>
            <template v-if="data.item.row_tool_option_fax == 1">
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'fax']" class="text-success" size="lg" :title="'Document will be sent by fax'"/>
              </span>
            </template>
            <template v-else>
              <span class="px-1">
                <fontAwesomeIcon v-if="data.item.row_tool_option_fax == 2" :icon="['fas', 'fax']" class="text-danger" size="lg" :title="'Document will not be sent by fax - fax disabled'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_fax == 3" :icon="['fas', 'fax']" class="text-danger" size="lg" :title="'Document will not be sent by fax - no fax present'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_fax == 4" :icon="['fas', 'fax']" class="text-danger" size="lg" :title="'Document will not be sent by fax - no fax present & function disabled'"/>
              </span>
            </template>
            <template v-if="data.item.row_tool_option_post == 1">
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'envelope']" class="text-success" size="lg" :title="'Document will be sent by post'"/>
              </span>
            </template>
            <template v-else>
              <span class="px-1">
                <fontAwesomeIcon v-if="data.item.row_tool_option_post == 2" :icon="['fas', 'envelope']" class="text-danger" size="lg" :title="'Document will not be sent by post - post disabled'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_post == 3" :icon="['fas', 'envelope']" class="text-danger" size="lg" :title="'Document will not be sent by post - no address present'"/>
                <fontAwesomeIcon v-if="data.item.row_tool_option_post == 4" :icon="['fas', 'envelope']" class="text-danger" size="lg" :title="'Document will not be sent by post - no address present & function disabled'"/>
              </span>
            </template>
            <template v-if="data.item.row_tool_option_datax">
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'download']" class="text-success" size="lg" :title="'Document will be sent by data transfer'"/>
              </span>
            </template>
            <template v-else>
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'download']" class="text-danger" size="lg" :title="'Document will not be sent by data transfer - data transfer disabled'"/>
              </span>
            </template>
            <!-- EIPP-477 Document deletion flag -->
            <template v-if="(Number(userLevel) >= 2.00) && data.item.to_be_deleted">
              <span class="px-1">
                <fontAwesomeIcon :icon="['fas', 'times']" class="text-danger" size="lg" :title="'This document will be deleted'"/>
              </span>
            </template>
          </div>
          <div v-else class="d-flex justify-content-center">
            <span @click="modalCreator({id: 'emailModal', title: t('documentsSearchEmailModalHead','documentsSearchEmailModalHead'), level: 'main', open: 'open', entries: 'single', wm: 'none', perm_wm_allowed: false}, {docsChecked: [data.item.id], statuses: [{docId: data.item.id , status: data.item.batch_status, customer: data.item.customer_ref, reference: data.item.reference}]}, $event.target)" class="showhand px-1">
              <fontAwesomeIcon :icon="['fas', 'at']" class="text-success" size="lg"/>
            </span>
            <span v-if="(Number(userLevel) > 0.50)">
              <span @click="modalCreator({id: 'faxModal', title: t('documentsSearchFaxModalHead','documentsSearchFaxModalHead'), level: 'main', open: 'open', entries: 'single', type: 'default'}, {docsChecked: [data.item.id], statuses: [{docId: data.item.id , status: data.item.batch_status, customer: data.item.customer_ref, reference: data.item.reference}]}, $event.target)"  class="showhand px-1">
                <fontAwesomeIcon :icon="['fas', 'fax']" class="text-success" size="lg"/>
              </span>
              <!--<span class="px-1">
                <fontAwesomeIcon  :icon="['fas', 'envelope']" class="text-faded-gray" size="lg"/>
              </span>-->
              <span @click="sendPostCopy(data.item.id, $event.target)" class="showhand px-1">
                <fontAwesomeIcon  :icon="['fas', 'envelope']" class="text-success" size="lg"/>
              </span>
            </span>
          </div>
        </template>
        <template v-slot:cell(currency)="data">
          <span class="hide-color"> {{data.item.currency}} </span>
        </template>
        <template v-slot:foot(checkbox)="data">
          <div></div>
        </template>
        <template v-slot:foot(customer_ref)="data">
          <div></div>
        </template>
        <template v-slot:foot(client_data_2)="data">
          <span v-if="(Object.entries(calculations).length !== 0) && (calculations.documentsSummary.documentsNetValue)" class="footer-summary-value">
            {{ calculations.documentsSummary.documentsNetValue | thousandsFormatter() }}
          </span>
          <span v-else></span>
        </template>
        <template v-slot:foot(customer_name)="data">
          <div></div>
        </template>
        <template v-slot:foot(type_name)="data">
          <div></div>
        </template>
        <template v-slot:foot(invoice_type)="data">
          <div></div>
        </template>
        <template v-slot:foot(document)="data">
          <div></div>
        </template>
        <template v-slot:foot(customer_type_name)="data">
          <div></div>
        </template>
        <template v-slot:foot(customer_type)="data">
          <div></div>
        </template>
        <template v-slot:foot(pages)="data">
          <div></div>
        </template>
        <template v-slot:foot(original_invoice)="data">
          <div></div>
        </template>
        <template v-slot:foot(value)="data">
          <span v-if="Object.entries(calculations).length !== 0" class="footer-summary-value" >
            <template v-if="calculations.documentsSummary && calculations.documentsSummary.documentsPageTotal">
              <template v-if="displaySettings.formatValues">
                {{ calculations.documentsSummary.documentsPageTotal | thousandsFormatter()  }}
              </template>
              <template v-else>
                {{ calculations.documentsSummary.documentsPageTotal | removeSeparator() }}
              </template>
            </template>
            <template v-else>
              <template v-if="displaySettings.formatValues">
                {{ calculations.documentsSummary.documentsPageTotal | thousandsFormatter() }}
              </template>
              <template v-else>
                {{ calculations.documentsSummary.documentsPageTotal | removeSeparator() }}
              </template>
            </template>
          </span>
          <span v-else></span>
        </template>
        <template v-slot:foot(total_gbp)="data">
          <span class="hide-color" v-if="calculations.documentsCurrencySums && calculations.documentsCurrencySums.total_gbp">{{ calculations.documentsCurrencySums.total_gbp | thousandsFormatter() }} {{ t('gbpCurrencySymbol', 'gbpCurrencySymbol') }}</span>
          <span v-else></span>
        </template>
        <template v-slot:foot(total_eur)="data">
          <span class="hide-color" v-if="calculations.documentsCurrencySums && calculations.documentsCurrencySums.total_eur">{{ calculations.documentsCurrencySums.total_eur | thousandsFormatter() }} {{ t('eurCurrencySymbol', 'eurCurrencySymbol') }}</span>
          <span v-else></span>
        </template>
        <template v-slot:foot(total_chf)="data">
          <span class="hide-color" v-if="calculations.documentsCurrencySums && calculations.documentsCurrencySums.total_chf">{{ calculations.documentsCurrencySums.total_chf | thousandsFormatter() }} {{ t('chfCurrencySymbol', 'chfCurrencySymbol') }}</span>
          <span v-else></span>
        </template>
        <template v-slot:foot(total_aud)="data">
          <span class="hide-color" v-if="calculations.documentsCurrencySums && calculations.documentsCurrencySums.total_aud">{{ calculations.documentsCurrencySums.total_aud }} {{ t('audCurrencySymbol', 'audCurrencySymbol') }}</span>
          <span v-else></span>
        </template>
        <template v-slot:foot(total_nok)="data">
          <span class="hide-color" v-if="calculations.documentsCurrencySums && calculations.documentsCurrencySums.total_nok">{{ calculations.documentsCurrencySums.total_nok }} {{ t('nokCurrencySymbol', 'nokCurrencySymbol') }}</span>
          <span v-else></span>
        </template>
        <template v-slot:foot(total_pln)="data">
          <span class="hide-color" v-if="calculations.documentsCurrencySums && calculations.documentsCurrencySums.total_pln">{{ calculations.documentsCurrencySums.total_pln }} {{ t('plnCurrencySymbol', 'plnCurrencySymbol') }}</span>
          <span v-else></span>
        </template>
        <template v-slot:foot(total_rub)="data">
          <span class="hide-color" v-if="calculations.documentsCurrencySums && calculations.documentsCurrencySums.total_rub">{{ calculations.documentsCurrencySums.total_rub }} {{ t('rubCurrencySymbol', 'rubCurrencySymbol') }}</span>
          <span v-else></span>
        </template>
        <template v-slot:foot(total_sek)="data">
          <span class="hide-color" v-if="calculations.documentsCurrencySums && calculations.documentsCurrencySums.total_sek">{{ calculations.documentsCurrencySums.total_sek }} {{ t('sekCurrencySymbol', 'sekCurrencySymbol') }}</span>
          <span v-else></span>
        </template>
        <template v-slot:foot(total_usd)="data">
          <span class="hide-color" v-if="calculations.documentsCurrencySums && calculations.documentsCurrencySums.total_usd">{{ calculations.documentsCurrencySums.total_usd | thousandsFormatter() }} {{ t('usdCurrencySymbol', 'usdCurrencySymbol') }}</span>
          <span v-else></span>
        </template>
        <template v-slot:foot(total_nzd)="data">
          <span class="hide-color" v-if="calculations.documentsCurrencySums && calculations.documentsCurrencySums.total_nzd">{{ calculations.documentsCurrencySums.total_nzd | thousandsFormatter() }} {{ t('nzdCurrencySymbol', 'nzdCurrencySymbol') }}</span>
          <span v-else></span>
        </template>
        <template v-slot:foot(client_data_1)="data">
          <div></div>
        </template>
        <template v-slot:foot(ship_to)="data">
          <div></div>
        </template>
        <template v-slot:foot(vat_value)="data">
          <span v-if="Object.entries(calculations).length !== 0" class="footer-summary-value">
            <template v-if="calculations.documentsSummary && calculations.documentsSummary.documentsPageVat">
              <template v-if="displaySettings.formatValues">
                {{ calculations.documentsSummary.documentsPageVat | thousandsFormatter() }}
              </template>
              <template v-else>
                {{ calculations.documentsSummary.documentsPageVat | removeSeparator() }}
              </template>
            </template>
            <template v-else>
              <template v-if="displaySettings.formatValues">
                {{ calculations.documentsSummary.documentsVatValue | thousandsFormatter() }}
              </template>
              <template v-else>
                {{ calculations.documentsSummary.documentsVatValue | removeSeparator() }}
              </template>
            </template>
          </span>
          <span v-else></span>
        </template>
        <template v-slot:foot()="data">
          <template v-if="data.field.type == 'currency_value'">
            <template v-if="calculations.documentsCurrencySums[data.field.key]">
              {{ calculations.documentsCurrencySums[data.field.key] }}
            </template>
          </template>
          <template v-else >
          </template>
        </template>
        <template v-slot:foot(doc_status)="data">
          <div></div>
        </template>
        <template v-slot:foot(date)="data">
          <div></div>
        </template>
        <template v-slot:foot(post_house)="data">
          <div></div>
        </template>
        <template v-slot:foot(send)="data">
          <div></div>
        </template>
        <template v-slot:foot(currency)="data">
          <div></div>
        </template>
        <template v-slot:foot(payment_status)="data">
          <div></div>
        </template>
      </b-table>
    </template>
    <ModalDocumentReceipt :receiptDocId="receiptDocId" />
  </div>
</template>

<script>
//import { mapGetters } from 'vuex'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import { VclTable } from 'vue-content-loading'
import ModalDocumentReceipt from '@/components/Documents_Search/ModalDocumentReceipt.vue'
import 'bootstrap-vue/dist/bootstrap-vue.css';

export default {
  name: 'ResultsTable',
  //this component inherits from the Search.vue component
  inject: [
    'proof',
    //modals
    'modalCreator',
    //result table functionality
    'isBusy',
    'isBusyTables',
    'getTablesBusy',
    'searchDocuments',

    //'sortBy',
    //'sortDesc',
    'changeSorting',

    'totalRows',
    'currentPage',
    'filter',
    'onFiltered',
    'rowEmpty',
    //document checkboxes
    'documentsData',
    'checkAllDocs',
    'unCheckAllDocs',
    'thisDocChecked',
    'collectDocStatus',
    //'allDocsToggle',
    //'localToggle',
    //result table display
    'userLevel',
    'clientName',
    'isHeadUser',
    'headUserCustomerRef',
    'changeMark',
    'belongToPrincipal',
    'totalValueReq',
    'vatValueReq',
    'markReq',
    'displayCurrency',
    'perPage',
    'userDocTypePaymentAllowed'
  ],
  data () {
    return {
      //to see the tag data, clientData1 and 2, and id of the document in each row
      //for testing purposes
      testing: false,
      footerFields: [
        {key: 'checkbox', label: ''},
        {key: 'customer_ref', label: ''},
        {key: 'customer_name', label: ''}
      ],
      allDocsToggle: false,
      sortBy: null,
      sortDesc: false,
      columnsAmount: 5,
      receiptDocId: null
    }
  },
  computed: {
    isMarkRequired() {
      if(this.$store.getters['documentsStore/getDisplaySettings']) {
        return (this.$store.getters['documentsStore/getDisplaySettings'].markReq) ? true : false
      }

      return  false
    },
    datePickerFormat: {
      get() {
        if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
          let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
          return dateformat
        } else {
          return "DD-MM-YYYY"
        }
      }
    },
    theTableIsBusy() {
      let tablesStatus = this.getTablesBusy()
      return tablesStatus
    },
    isLoading() {
      return this.$attrs.isLoading
    },
    isInfinite() {
      return this.$attrs.isInfinite
    },
    fields() {
      if(this.tableType == 'default' || (!this.clientSpecificFields || Object.keys(this.clientSpecificFields).length == 0)) {
        let totalValueReq = this.totalValueReq
        let vatValueReq = this.vatValueReq
        let userLevel = this.userLevel
        let proof = this.proof
        let markReq = this.markReq
        let displayCurrency = this.displayCurrency

        let hasClientData1 = false;
        let hasClientData2 = false;

        if(this.documents) {
          if(this.documents.data) {
            for(let i = 0; i < this.documents.data.length; i++) {
              if (this.documents.data[i].client_data_1) {
                hasClientData1 = true;
                break;
              }
            }
            for(let i = 0; i < this.documents.data.length; i++) {
              if (this.documents.data[i].client_data_2) {
                hasClientData2 = true;
                break;
              }
            }
          }
        }

        let pagesField, totalField, clientData1Field, clientData2Field, vatField, docStatusField, currencyField = undefined

        if(userLevel >= 2.00) {
          pagesField = {key: 'pages', label: 'tableHeadPages', sortable: true, thClass: 'showhand'}
        }
        if(totalValueReq) {
          totalField = {key: 'value', label: 'tableHeadValue', sortable: true, thClass: 'showhand'}
        }
        if(hasClientData1 && ((this.clientName == 'news') || (this.clientName == 'newstest'))) {
          clientData1Field = {key: 'client_data_1', label: this.clientDataName1, sortable: true, thClass: 'showhand'}
        }
        if(hasClientData2) {
          clientData1Field = {key: 'client_data_2', label: this.clientDataName2, sortable: true, thClass: 'showhand'}
        }
        if(vatValueReq && (userLevel >= vatValueReq) && this.clientName != 'gskp' && this.clientName != 'gskptest') {
          let labelVat = 'tableHeadVat';

          if (this.clientName === 'lous' || this.clientName === 'loustest') {
            labelVat = 'tableHeadTax';
          }

          vatField = {key: 'vat_value', label: labelVat, sortable: true, thClass: 'showhand'}
        }
        if((proof == 'approved') && this.isMarkRequired) {
          docStatusField = {key: 'doc_status', label: 'tableHeadDocStatus', sortable: true, thClass: 'showhand'}
        }
        if(displayCurrency) {
          currencyField = {key: 'currency', label: 'tableHeadCurrency'}
        }
        let fields = [
          {key: 'checkbox', label: '', sortable: false},
          {key: 'customer_ref', label: 'tableHeadReference', sortable: true, thClass: 'showhand'},
          {key: 'customer_name', label: 'tableHeadName', sortable: true, thClass: 'showhand'},
          {key: 'type_name', label: 'tableHeadType', sortable: true, thClass: 'showhand'},
          {key: 'document', label: 'tableHeadDocument', sortable: true, thClass: 'showhand'},
          pagesField,
          totalField,
          clientData1Field,
          clientData2Field,
          vatField,
          docStatusField,
          {key: 'date', label: 'tableHeadDate', sortable: true, thClass: 'showhand'},
          //the send column is available only if the batch is not proof
          {key: 'send', label: 'tableHeadSend', sortable: false, thClass: 'showhand'},
          currencyField
        ]
        return fields
      } else {
        if(this.clientSpecificFields && Object.keys(this.clientSpecificFields).length > 0) {
          let fields = []

          // NS-10009 Translate the client specific table headers, PW
          Object.keys(this.clientSpecificFields).forEach(function(key) {
            if(this.clientSpecificFields[key]) {
              if(this.clientSpecificFields[key].label) {
                this.clientSpecificFields[key].label = this.$t(this.clientSpecificFields[key].label, this.clientSpecificFields[key].label)
              }
            }
          }, this)

          Object.keys(this.clientSpecificFields).forEach((key) => (fields.push(this.clientSpecificFields[key])))

          return fields
        }
      }
    },
    displaySettings: {
      get() {
        return this.$store.getters['documentsStore/getDisplaySettings']
      },
      set(newDisplaySettings) {
        this.$store.commit('documentsStore/setDisplaySettings', newDisplaySettings)
      }
    },
    // responsible for getting the table headers
    clientSpecificFields() {
      if(this.$store.getters['documentsStore/getClientSpecificFields']) {
        this.columnsAmount = this.$store.getters['documentsStore/getClientSpecificFields'].length
        return this.$store.getters['documentsStore/getClientSpecificFields']
      }
    },
    // responsible for getting the table contents ( documents )
    documents() {
      return this.$store.getters['documentsStore/getDocuments']
    },
    getUserDocTypePaymentAllowed() {
      return this.$store.getters['documentsStore/getUserDocTypePaymentAllowed']
    },
    calculations() {
      return this.$store.getters['documentsStore/getCalculations']
    },
    clientDataName1() {
      return this.$store.getters.allTemplateDetails.client_data_1_name
    },
    clientDataName2() {
      return this.$store.getters.allTemplateDetails.client_data_2_name
    }
  },
  methods: {
    sendPostCopy(docId, target) {
      // format the data so it can be supported
      let docArray = new Array()
      docArray.docsChecked = new Array()
      docArray['docsChecked'].push(docId)
      this.modalCreator({id: 'postModal', title: this.t('documentsSearchPostModalHead', 'documentsSearchPostModalHead'), level: 'main', open: 'open', entries: 'single', type: 'default'}, docArray, target)
    },

    handleCheckbox(docId) {
        document.getElementById('documents-table-client-specific__row_' + docId ).classList.remove('bg-danger')
        document.getElementById('documents-table-client-specific__row_' + docId ).classList.remove('text-white')
    },
    setAsRead(docId) {
      //NS-9940 SP changing the document id parameter from array to variable
      // changed way we mark doc as read to just edit one variable instead of searching all docs again, PW
      // we set the doc as read only if its a customer user opening it
      if(this.$store.getters['getUserLevel'] == '0.00') {
        this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'markDocumentsRead', documents: docId}).then(() => {

          // part to add the read icon after clicking, since we do it only for customers user level and they cant see those icon there is no need to show it, PW
          /*if(typeof docId == 'number') {
            let documentId = docId
            let index = this.documents.data.findIndex(doc => doc.id == documentId)

            if(this.documents.data[index].is_read == 0)
            {
              this.documents.data[index].is_read = 1
              this.documents.data[index].read_by = this.$store.getters['getUserDetails'].email
            }
          }*/
        }, this)
      }
    },
    readTooltip(readBy, readOn) {
      return 'Read by: <b>' + readBy + '</b> </br>On: <b>' + moment(readOn).format(this.datePickerFormat) + '</b> </br>' + 'At: <b>' + moment(readOn).format('h:mm:ss a') + '</b>'
    },
    downloadTooltip(downloadedBy, downloadedOn) {
      return 'Downloaded by: <b>' + downloadedBy + '</b> </br>On: <b>' + moment(downloadedOn).format(this.datePickerFormat) + '</b> </br>' + 'At: <b>' + moment(downloadedOn).format('h:mm:ss a') + '</b>'
    },
    acceptTooltip(acceptedBy, acceptedOn) {

    },
    sortingChanged(ctx) {
      let sortField = ctx.sortBy
      let sortOrder = (ctx.sortDesc == true) ? 'ASC' : 'DESC'
      this.sortBy = sortField
      this.sortDesc = ctx.sortDesc
      this.changeSorting(sortField, sortOrder)
    },
    loaderStopped() {
      this.loaderBusy = false
    },
    rowClass(item) {
      if (!item) return
      let rowClasses = []
      let isHidden = (item.is_hidden != 0.0) ? 'row-hidden' : null
      let isRead = (!item.is_read) ? 'row-unread' : null
      rowClasses.push(isHidden, isRead)

      return rowClasses
    },
    clientSpecificHead(field) {
      return `head(${field})`;
    },
    clientSpecificCell(field) {
      return `cell(${field})`;
    },
    localToggle(bool) {
      this.allDocsToggle = bool
    },
    routeToCustomers(customerRef) {
      //this.$router.push({ name: 'manage_customers', query: { referenceB: customerRef} })
      this.$router.push({ name: 'manage_customers', query: { customerReference: customerRef} })
    },
    /*
    routeToDocumentView(docId, watermark) {
      this.$router.push({ name: 'documents', query: { document: docId, wm: watermark} })
    },
    */
    routeToDocumentCover(docId, coverType) {
      this.$router.push({ name: 'documents', query: { document: docId, type: coverType} })
    },
    routeToDeliveryReport(docId) {
      this.$router.push({name:'delivery_reports', query: {page: 1, per_page: 20}, params: {docs: Array.of(docId)}})
    },
    routeToDocumentView(docId, watermarkType = null, type) {
      // NS-10011 Change to link for opening document to not affect the main page, PW
      let newTab = null

      // resolve function generates url based on the path name and parameters
      if(watermarkType) {
        newTab = this.$router.resolve({ name: 'view_document', params: { id: docId, type: type, stamp: watermarkType }})
      } else {
        newTab = this.$router.resolve({ name: 'view_document', params: { id: docId, type: type }})
      }

      window.open(newTab.href, '_blank')
    },
    openReceiptModal(docId) {
      this.receiptDocId = docId
      this.$root.$emit('bv::show::modal', 'documentReceipt')
      this.$parent.alertShowing = true

    },
    closeReceipt() {
      this.$root.$emit('bv::hide::modal', 'documentReceipt')
      this.$parent.alertShowing = false
    }
  },
  created() {
    this.tableType = this.$attrs.tableType
  },
  filters: {
    //#EIPP-561 modified the function to remove the bug where decomal values will convert to Int.
    // additionally created a fallback behavior so if the function fails it will call thousandsFormatter. IS
    numberFormat: function(number, digits) {
      let numberToParse = Number(number);

      try {
        if(typeof numberToParse !== 'number'){
          throw new TypeError("number format can only format numbers please purify the value. system has fallen back to thousand's formatter");
        }
        return numberToParse.toFixed(digits);
      }catch (e) {
        this.$logError(e);
      }
      return this.thousandsFormatter(number);
    },
    // NS-10071 Thousands separator by 1000
    thousandsFormatter: function(value) {
      let valToParse = '0'

      if (value) {
        if (typeof value !== 'string' || !value instanceof String) {
          valToParse = value.toString()
        } else {
          valToParse = value
        }
      }

      if (!valToParse.includes(',')) {
        // NS-10611 Added extra condition to ensure decimals will be showing, PW
        let number = Number.parseFloat(valToParse)

        if (isNaN(number)) {
          return valToParse
        }

        return number.toLocaleString('en', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }

      return valToParse
    },
    removeSeparator: function(value) {
      value = value.replace(/,/g, '')
      return value
    },
    truncate: function(ref, length) {
      return ref.substring(0, length)
    },
    clientDateFormatter: function(date, datePickerFormat, withTime) {
      if(withTime) {
        return moment(date).format(datePickerFormat + ' h:mm:ss')
      } else {
        return moment(date).format(datePickerFormat)
      }
    },

    paymentColumnText: function (statusText, userDocTypeId, docTypesPaymentAllowed) {
      if(docTypesPaymentAllowed.indexOf(userDocTypeId) == -1) {
        return '[Payment Not Allowed]'
      }

      if(!statusText) {
        statusText = 'Unpaid'
      }

      return statusText.charAt(0).toUpperCase() + statusText.slice(1)
    }
  },
  components: {
    Loading,
    VclTable,
    ModalDocumentReceipt
  }
}
</script>

<style scoped>
.showhand {
  cursor: pointer;
}

/*MIMICKING THE DEFAULT URL STYLE FOR HREF-LESS a ELEMENTS*/
.url {
  color: #047bf8 !important;
  cursor: pointer;
}
.url:hover{
  text-decoration: underline !important;
}

/*TABLE*/
.table-responsive  >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}
.table-responsive  >>> .footer-summary {
  background-color: lightgrey !important;
}
.table-responsive >>> .row-hidden{
  font-style: italic;
}
.table-responsive >>> .row-hidden a{
  color: grey !important;
  /*text-decoration: underline;*/
}
.table-responsive >>> .row-hidden .hide-color{
  color: grey !important;
}
.table-responsive >>> .row-unread{
  font-weight: bold;
}


/*ICONS in the table rows*/
.bg-yellow {
  background-color: #ff9800 !important;
  font-weight: bold;
  font-style: normal;
}
.bg-green {
  background-color: #4caf50 !important;
  font-weight: bold;
  font-style: normal;
}
.bg-blue {
  background-color: #03a9f4 !important;
  font-weight: bold;
  font-style: normal;
}

.double-icon {
  position: relative;
}
.bottom-icon{
  z-index:0;
  position: absolute;
  margin-top: 7px;
  margin-left: 7px;
}
.top-icon{
  position: absolute;
  z-index:5;
}
.icon-margin-right{
  margin-right: 35px;
}

/*TABLE FOOTER*/
.footer-summary-value{
  font-size: 13px !important;
}

.text-faded-gray{
  color: gray;
  opacity: 0.5;
}
</style>
